import styled from 'react-emotion'
import { mobile, customDevice, tablet } from '../../../../utils/mixins'
import CloudinaryS3LazyLoadedImage from '../../../CloudinaryS3LazyLoadedImage'

export const PartnersSectionContainer = styled('div')`
  width: 60%;
  ${mobile} {
    width: 100%;
  }
  ${tablet} {
    width: 85%;
  }
`

export const PartnersInnerContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  ${customDevice(360, 500)} {
    justify-content: space-evenly;
  }
`

export const PartnerWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 22px;
  margin-bottom: 22px;
  min-width: 110px;
  ${mobile} {
    margin-left: 0px;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: unset;
  }
  ${tablet} {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 30px;
    margin-bottom: 30px;
    min-width: unset;
  }
`
export const PartnerLogo = styled(CloudinaryS3LazyLoadedImage)`
  height: 100px;
  object-fit: contain;
  width: 100px;
  ${mobile} {
    height: 80px;
  }
  ${tablet} {
    height: 70px;
    width: 70px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/PartnersSection/styledComponents.js